import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 8,
				cy: 8,
				r: 8,
				fill: "#FF3131"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 6L9.99952 9.99952",
				stroke: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 6L6.00048 9.99952",
				stroke: "white"
			})
		]
	})
});
export default SvgDelete;
